'use strict';

var isMobile = require('../../services-utils-js/mobileDetector');

module.exports = /*@ngInject*/ function($scope, $analytics) {
	var vm = this;
	vm.isAnyMobile = !!isMobile.any();

};